/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import { phoneWirelessDuocolor } from "../assets/phone-wireless-duocolor";
import {
  type StaticIllustrativeBaseIconProps,
  StaticIllustrativeIcon,
} from "../static-illustrative-icon";

export const IllustrativeIconPhoneWirelessDuocolor = (props: StaticIllustrativeBaseIconProps) => (
  <StaticIllustrativeIcon {...props} svg={phoneWirelessDuocolor.svg} />
);

IllustrativeIconPhoneWirelessDuocolor.displayName = "IllustrativeIconPhoneWirelessDuocolor";
